import React from 'react'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'
import './SelectableCheckboxList.scss'

const SelectableCheckboxList = ({
  label,
  items = [],
  activeId,
  setActiveId = () => {
    // console.warn('setActiveId not provided')
  },
  setChecked = () => {
    // console.warn('setChecked not provided')
  },
  checked = [],
  setActiveChanges = () => {
    // console.warn('setActiveChanges not provided')
  },
  clearProperties = () => {
    // console.warn('clearProperties not provided')
  },
  disabled,
}) => {
  return (
    <div>
      <div className="scrollable-checkbox-list-label">{label}</div>
      <div className="scrollable-checkbox-list selectable">
        {items.map(({ label, id }) => {
          return (
            <SelectableCheckbox
              label={label}
              key={id}
              active={activeId === id}
              onClick={() => {
                !disabled && setActiveId(id)
              }}
              onChange={() => {
                clearProperties()
                setActiveChanges()
                let nextChecked = [...checked]
                if (!nextChecked.includes(id)) {
                  // doesn't exist or is already false
                  nextChecked.push(id)
                } else {
                  nextChecked = nextChecked.filter((item) => item !== id)
                }
                setChecked(nextChecked)
              }}
              checked={checked.includes(id) ? true : false}
              disabled={disabled}
            />
          )
        })}
      </div>
    </div>
  )
}

export default SelectableCheckboxList

export const SelectableCheckbox = ({ label, active, onClick, onChange, checked, disabled }) => {
  return (
    <div className={`checkbox-wrapper ${active ? 'active' : ''}`} onClick={onClick}>
      <Checkbox
        ariaLabel={label}
        customCss={'width: fit-content'}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <div className="checkbox-label">{label}</div>
    </div>
  )
}

export const CheckboxList = ({
  label,
  items,
  checkedIds,
  setChecked,
  setActiveChanges = () => {},
  disabled,
}) => {
  return (
    <div>
      <div className="scrollable-checkbox-list-label">{label}</div>
      <div className="scrollable-checkbox-list">
        {items.map(({ label, id }) => {
          return (
            <Checkbox
              label={label}
              key={id}
              checked={checkedIds.includes(id) ? true : false}
              onChange={() => {
                setActiveChanges()
                let nextChecked = [...checkedIds]
                if (!nextChecked.includes(id)) {
                  // doesn't exist or is already false
                  nextChecked.push(id)
                } else {
                  nextChecked = nextChecked.filter((item) => item !== id)
                }
                setChecked(nextChecked)
              }}
              disabled={disabled}
            />
          )
        })}
      </div>
    </div>
  )
}
